import {
    List,
    Datagrid,
    TextField,
    EditButton,
    DateField,
} from 'react-admin';

export const ContactUsList = () => (
    <List>
        <Datagrid>
            <TextField source="id" sortable={false} />
            <TextField source="name" sortable={false} />
            <TextField source="email" sortable={false} />
            <TextField source="phone_number" sortable={false} />
            <TextField source="message" sortable={false} />
            <DateField source="CreatedAt" showTime={true} sortable={false} />
            <DateField source="UpdatedAt" showTime={true} sortable={false} />
        </Datagrid>
    </List>
);